import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import Advisory from "../views/Advisory";
import Assurance from "../views/Assurance";
import Tax from "../views/Tax";
import Legal from "../views/Legal";
import ManagementAccounting from "../views/ManagementAccounting";
import InternalAudit from "../views/InternalAudit";
import ProjectManagement from "../views/ProjectManagement";

export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if(
			appContext.navSubItem === 'advisory' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Advisory/>
		} else if(
			appContext.navSubItem === 'assurance' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Assurance/>
		} else if(
			appContext.navSubItem === 'taxation' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Tax/>
		} else if(
			appContext.navSubItem === 'legal' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Legal/>
		} else if(
			appContext.navSubItem === 'accounting' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ManagementAccounting />
		} else if(
			appContext.navSubItem === 'internal-audit' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <InternalAudit />
		} else if(
			appContext.navSubItem === 'project-management' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ProjectManagement />
		} 
			return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}